import clsx from 'clsx'
import classes from './Icons.module.scss'

export function SVGDownloadIcon() {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.75 16.4167C0.75 17.1461 1.03973 17.8455 1.55546 18.3613C2.07118 18.877 2.77065 19.1667 3.5 19.1667H14.5C15.2293 19.1667 15.9288 18.877 16.4445 18.3613C16.9603 17.8455 17.25 17.1461 17.25 16.4167V7.09237C17.2496 6.36341 16.9598 5.66442 16.4443 5.14904L12.9352 1.63821C12.4195 1.12278 11.7202 0.833287 10.991 0.833374H3.5C2.77065 0.833374 2.07118 1.12311 1.55546 1.63883C1.03973 2.15456 0.75 2.85403 0.75 3.58337V16.4167ZM3.5 17.3334C3.25688 17.3334 3.02373 17.2368 2.85182 17.0649C2.67991 16.893 2.58333 16.6598 2.58333 16.4167V3.58337C2.58333 3.34026 2.67991 3.1071 2.85182 2.93519C3.02373 2.76328 3.25688 2.66671 3.5 2.66671H9.91667V5.41671C9.91667 6.14605 10.2064 6.84553 10.7221 7.36125C11.2378 7.87698 11.9373 8.16671 12.6667 8.16671H15.4167V16.4167C15.4167 16.6598 15.3201 16.893 15.1482 17.0649C14.9763 17.2368 14.7431 17.3334 14.5 17.3334H3.5ZM15.0372 6.33337H12.6667C12.4236 6.33337 12.1904 6.2368 12.0185 6.06489C11.8466 5.89298 11.75 5.65982 11.75 5.41671V3.04621L15.0372 6.33337Z"
        fill="#DBDBDB"
      />
      <path
        d="M8.99971 9.08337C9.24282 9.08337 9.47598 9.17995 9.64789 9.35186C9.8198 9.52377 9.91637 9.75693 9.91637 10V13.2872L11.1016 12.102C11.2745 11.935 11.5061 11.8426 11.7464 11.8447C11.9868 11.8468 12.2167 11.9432 12.3866 12.1131C12.5566 12.2831 12.653 12.513 12.6551 12.7533C12.6572 12.9937 12.5648 13.2252 12.3978 13.3981L9.64779 16.1481C9.47589 16.32 9.24277 16.4165 8.99971 16.4165C8.75664 16.4165 8.52352 16.32 8.35162 16.1481L5.60163 13.3981C5.51407 13.3136 5.44424 13.2124 5.3962 13.1006C5.34816 12.9887 5.32287 12.8685 5.32181 12.7467C5.32075 12.625 5.34395 12.5043 5.39004 12.3917C5.43613 12.279 5.50419 12.1767 5.59026 12.0906C5.67633 12.0045 5.77868 11.9365 5.89133 11.8904C6.00399 11.8443 6.12469 11.8211 6.24641 11.8221C6.36812 11.8232 6.48841 11.8485 6.60025 11.8965C6.71208 11.9446 6.81323 12.0144 6.89779 12.102L8.08304 13.2872V10C8.08304 9.75693 8.17962 9.52377 8.35153 9.35186C8.52344 9.17995 8.75659 9.08337 8.99971 9.08337Z"
        fill="#DBDBDB"
      />
    </svg>
  )
}

export const SVGListIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.7275 13.6685C5.613 13.6685 6.33166 14.3871 6.33166 15.2726V17.5625C6.33166 17.9879 6.16265 18.396 5.86181 18.6968C5.56097 18.9976 5.15295 19.1666 4.7275 19.1666H2.43766C2.01221 19.1666 1.60419 18.9976 1.30335 18.6968C1.00251 18.396 0.833496 17.9879 0.833496 17.5625V15.2726C0.833496 14.3871 1.55216 13.6685 2.43766 13.6685H4.7275ZM4.7275 15.0435H2.43766C2.37688 15.0435 2.31859 15.0676 2.27562 15.1106C2.23264 15.1536 2.2085 15.2119 2.2085 15.2726V17.5625C2.2085 17.689 2.31116 17.7916 2.43766 17.7916H4.7275C4.78827 17.7916 4.84656 17.7675 4.88954 17.7245C4.93252 17.6815 4.95666 17.6233 4.95666 17.5625V15.2726C4.95666 15.2119 4.93252 15.1536 4.88954 15.1106C4.84656 15.0676 4.78827 15.0435 4.7275 15.0435ZM7.93583 15.5H18.4821C18.6563 15.5 18.8239 15.5662 18.9512 15.6851C19.0785 15.804 19.1559 15.9668 19.1678 16.1406C19.1796 16.3144 19.1251 16.4862 19.0152 16.6213C18.9053 16.7565 18.7481 16.8448 18.5756 16.8686L18.4821 16.875H7.93583C7.76164 16.8749 7.59397 16.8088 7.46669 16.6898C7.33941 16.5709 7.26201 16.4081 7.25014 16.2343C7.23827 16.0606 7.2928 15.8887 7.40273 15.7536C7.51265 15.6185 7.66977 15.5301 7.84233 15.5064L7.93583 15.5H18.4821H7.93583ZM4.7275 7.2509C5.613 7.2509 6.33166 7.96956 6.33166 8.85506V11.1449C6.33166 11.5703 6.16265 11.9784 5.86181 12.2792C5.56097 12.5801 5.15295 12.7491 4.7275 12.7491H2.43766C2.01221 12.7491 1.60419 12.5801 1.30335 12.2792C1.00251 11.9784 0.833496 11.5703 0.833496 11.1449V8.85415C0.833496 7.96865 1.55216 7.24998 2.43766 7.24998H4.7275V7.2509ZM4.7275 8.6259H2.43766C2.37688 8.6259 2.31859 8.65004 2.27562 8.69302C2.23264 8.736 2.2085 8.79428 2.2085 8.85506V11.1449C2.2085 11.2714 2.31116 11.3741 2.43766 11.3741H4.7275C4.78827 11.3741 4.84656 11.3499 4.88954 11.3069C4.93252 11.264 4.95666 11.2057 4.95666 11.1449V8.85415C4.95666 8.79337 4.93252 8.73508 4.88954 8.6921C4.84656 8.64912 4.78827 8.62498 4.7275 8.62498V8.6259ZM7.93583 9.08331H18.4821C18.6563 9.08337 18.8239 9.14954 18.9512 9.26846C19.0785 9.38737 19.1559 9.55017 19.1678 9.72395C19.1796 9.89774 19.1251 10.0695 19.0152 10.2047C18.9053 10.3398 18.7481 10.4282 18.5756 10.4519L18.4821 10.4583H7.93583C7.76164 10.4583 7.59397 10.3921 7.46669 10.2732C7.33941 10.1543 7.26201 9.99146 7.25014 9.81767C7.23827 9.64389 7.2928 9.47208 7.40273 9.33696C7.51265 9.20183 7.66977 9.11347 7.84233 9.08973L7.93583 9.08331H18.4821H7.93583ZM4.7275 0.833313C5.613 0.833313 6.33166 1.55198 6.33166 2.43748V4.72731C6.33166 5.15276 6.16265 5.56079 5.86181 5.86163C5.56097 6.16247 5.15295 6.33148 4.7275 6.33148H2.43766C2.01221 6.33148 1.60419 6.16247 1.30335 5.86163C1.00251 5.56079 0.833496 5.15276 0.833496 4.72731V2.43748C0.833496 1.55198 1.55216 0.833313 2.43766 0.833313H4.7275ZM4.7275 2.20831H2.43766C2.37688 2.20831 2.31859 2.23246 2.27562 2.27543C2.23264 2.31841 2.2085 2.3767 2.2085 2.43748V4.72731C2.2085 4.85381 2.31116 4.95648 2.43766 4.95648H4.7275C4.78827 4.95648 4.84656 4.93234 4.88954 4.88936C4.93252 4.84638 4.95666 4.78809 4.95666 4.72731V2.43748C4.95666 2.3767 4.93252 2.31841 4.88954 2.27543C4.84656 2.23246 4.78827 2.20831 4.7275 2.20831ZM7.93583 2.66665H18.4821C18.6563 2.6667 18.8239 2.73287 18.9512 2.85179C19.0785 2.97071 19.1559 3.1335 19.1678 3.30729C19.1796 3.48107 19.1251 3.65288 19.0152 3.788C18.9053 3.92313 18.7481 4.01149 18.5756 4.03523L18.4821 4.04165H7.93583C7.76164 4.04159 7.59397 3.97542 7.46669 3.8565C7.33941 3.73759 7.26201 3.57479 7.25014 3.40101C7.23827 3.22722 7.2928 3.05541 7.40273 2.92029C7.51265 2.78517 7.66977 2.69681 7.84233 2.67306L7.93583 2.66665H18.4821H7.93583Z"
      fill="#DBDBDB"
    />
  </svg>
)

export const SVGPreviewIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.2714 10.7662C20.4628 8.67463 19.0591 6.8658 17.2336 5.56331C15.4082 4.26082 13.2411 3.52177 11.0002 3.4375C8.7593 3.52177 6.59221 4.26082 4.76677 5.56331C2.94133 6.8658 1.53756 8.67463 0.728946 10.7662C0.674336 10.9173 0.674336 11.0827 0.728946 11.2338C1.53756 13.3254 2.94133 15.1342 4.76677 16.4367C6.59221 17.7392 8.7593 18.4782 11.0002 18.5625C13.2411 18.4782 15.4082 17.7392 17.2336 16.4367C19.0591 15.1342 20.4628 13.3254 21.2714 11.2338C21.3261 11.0827 21.3261 10.9173 21.2714 10.7662ZM11.0002 17.1875C7.35645 17.1875 3.50645 14.4856 2.11082 11C3.50645 7.51437 7.35645 4.8125 11.0002 4.8125C14.6439 4.8125 18.4939 7.51437 19.8896 11C18.4939 14.4856 14.6439 17.1875 11.0002 17.1875Z"
      fill="#DBDBDB"
    />
    <path
      d="M11 6.875C10.1842 6.875 9.38663 7.11693 8.70827 7.57019C8.02992 8.02345 7.50121 8.66769 7.189 9.42143C6.87679 10.1752 6.7951 11.0046 6.95426 11.8047C7.11343 12.6049 7.50629 13.3399 8.08319 13.9168C8.66008 14.4937 9.39508 14.8866 10.1953 15.0457C10.9954 15.2049 11.8248 15.1232 12.5786 14.811C13.3323 14.4988 13.9766 13.9701 14.4298 13.2917C14.8831 12.6134 15.125 11.8158 15.125 11C15.125 9.90598 14.6904 8.85677 13.9168 8.08318C13.1432 7.3096 12.094 6.875 11 6.875ZM11 13.75C10.4561 13.75 9.92442 13.5887 9.47218 13.2865C9.01995 12.9844 8.66747 12.5549 8.45933 12.0524C8.25119 11.5499 8.19673 10.997 8.30284 10.4635C8.40895 9.93005 8.67086 9.44005 9.05546 9.05546C9.44005 8.67086 9.93006 8.40895 10.4635 8.30284C10.997 8.19673 11.5499 8.25119 12.0524 8.45933C12.5549 8.66747 12.9844 9.01995 13.2865 9.47218C13.5887 9.92442 13.75 10.4561 13.75 11C13.75 11.7293 13.4603 12.4288 12.9445 12.9445C12.4288 13.4603 11.7293 13.75 11 13.75Z"
      fill="#DBDBDB"
    />
  </svg>
)

export const SVGGenerateIcon = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 1.75H7C6.03487 1.75 5.25 2.53488 5.25 3.5V14C5.25 14.9651 6.03487 15.75 7 15.75H17.5C18.4651 15.75 19.25 14.9651 19.25 14V3.5C19.25 2.53488 18.4651 1.75 17.5 1.75ZM7 14V3.5H17.5L17.5018 14H7Z"
      fill="#DBDBDB"
    />
    <path
      d="M3.5 7H1.75V17.5C1.75 18.4651 2.53488 19.25 3.5 19.25H14V17.5H3.5V7ZM13.125 5.25H11.375V7.875H8.75V9.625H11.375V12.25H13.125V9.625H15.75V7.875H13.125V5.25Z"
      fill="#DBDBDB"
    />
  </svg>
)

export const SVGDeleteIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.21094 1.6173H5.03125C5.13008 1.6173 5.21094 1.53643 5.21094 1.4376V1.6173H12.0391V1.4376C12.0391 1.53643 12.1199 1.6173 12.2188 1.6173H12.0391V3.2346H13.6562V1.4376C13.6562 0.644674 13.0116 0 12.2188 0H5.03125C4.23838 0 3.59375 0.644674 3.59375 1.4376V3.2346H5.21094V1.6173ZM16.5312 3.2346H0.71875C0.321191 3.2346 0 3.55581 0 3.9534V4.6722C0 4.77103 0.0808594 4.8519 0.179688 4.8519H1.53633L2.09111 16.5998C2.12705 17.3658 2.76045 17.97 3.52637 17.97H13.7236C14.4918 17.97 15.1229 17.368 15.1589 16.5998L15.7137 4.8519H17.0703C17.1691 4.8519 17.25 4.77103 17.25 4.6722V3.9534C17.25 3.55581 16.9288 3.2346 16.5312 3.2346ZM13.5507 16.3527H3.69932L3.15576 4.8519H14.0942L13.5507 16.3527Z"
      fill="#DBDBDB"
    />
  </svg>
)

export const SVGWarningIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="exclamation-triangle"
    role="img"
    viewBox="0 0 576 512"
  >
    <path
      fill="currentColor"
      d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
    />
  </svg>
)

export function DownloadIcon({ onClick = () => {} }) {
  return (
    <button className={classes.DownloadIcon} onClick={onClick}>
      <SVGDownloadIcon />
    </button>
  )
}

export function ListIcon({ onClick = () => {} }) {
  return (
    <button className={classes.ListIcon} onClick={onClick}>
      <SVGListIcon />
    </button>
  )
}

export function PreviewIcon({ onClick = () => {} }) {
  return (
    <button className={classes.PreviewIcon} onClick={onClick}>
      <SVGPreviewIcon />
    </button>
  )
}

export function GenerateIcon({ onClick = () => {} }) {
  return (
    <button className={classes.GenerateIcon} onClick={onClick}>
      <SVGGenerateIcon />
    </button>
  )
}

export function DeleteIcon({ onClick = () => {} }) {
  return (
    <button className={classes.DeleteIcon} onClick={onClick}>
      <SVGDeleteIcon />
    </button>
  )
}

export function WarningIcon({ onClick = () => {}, className = '' }) {
  return (
    <button className={clsx(classes.WarningIcon, className)} onClick={onClick}>
      <SVGWarningIcon />
    </button>
  )
}
